<script setup lang="ts" stup>
import type { SubmitResult } from '~/layers/forms/types/submitResult'

interface Props {
  submitResult: SubmitResult
  resetSubmitResultFunction: () => void
}

const props = defineProps<Props>()

const { LocalConfigurationStore } = stores()

const errorReason = computed(() => {
  const failedMessages = LocalConfigurationStore.value?.feedbackSubmision?.FAILED
  if (props.submitResult.reason === 'FINANCE') return failedMessages?.FINANCE
  return failedMessages?.PROCESS_ERROR
})
</script>

<template>
  <template v-if="submitResult.result">
    <div class="flex flex-col justify-center gap-5 py-4 lg:flex lg:flex-wrap">
      <template v-if="submitResult?.result === 'SUCCESS'">
        <div class="flex flex-col justify-center gap-4 text-center">
          <CardComponent
            bg="light"
            class="col-span-full"
          >
            <div class="p-2 text-center text-xl"> Gracias por adquirir nuestro producto </div>
          </CardComponent>
          <GridComponent
            :cols="3"
            :min-cols="1"
          >
            <CardComponent
              v-for="message of LocalConfigurationStore?.feedbackSubmision?.SUCCESS"
              :key="message.text"
              bg="light"
            >
              <div class="flex flex-col items-center gap-4 p-4">
                <div class="flex items-center justify-center rounded-full bg-primary/40 p-3">
                  <span
                    :class="getIconClass(message.icon)"
                    class="text-3xl text-current"
                  />
                </div>
                <div class="text-center">{{ message.text }}</div>
              </div>
            </CardComponent>
          </GridComponent>
        </div>
      </template>
      <template v-if="submitResult?.result === 'FAILED'">
        <div class="text-center">
          <div>
            <span class="icon-[ph--info-bold] text-4xl" />
          </div>
          <template v-if="submitResult.reason">
            {{ errorReason }}
          </template>
        </div>
      </template>
      <div class="flex gap-4 lg:flex lg:justify-center">
        <PvButton
          v-if="submitResult?.result === 'FAILED'"
          label="Regresar al formulario"
          @click="resetSubmitResultFunction()"
        />
        <PvButton
          label="Volver a la pantalla de inicio"
          outlined
          as="a"
          href="/"
        />
      </div>
    </div>
  </template>
</template>
